export const googleSitesMessages = {
  copySuccess: 'The Google Site was copied successfully.',
  copyError: 'The Google Site was not copied successfully.',
  unknownError: 'Something went wrong!',
};
